import { render, staticRenderFns } from "./Stempelungen.vue?vue&type=template&id=3e5b04c8&scoped=true"
import script from "./Stempelungen.vue?vue&type=script&lang=ts"
export * from "./Stempelungen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5b04c8",
  null
  
)

export default component.exports